import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllUsers } from './useLoadAllUsers';

export interface ISetSendOnBehalfPermissionsVariables {
	permissions: Api.ISendOnBehalfPermission[];
	user: Api.IUser;
}

export function useSetSendOnBehalfPermissionsMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue, variables: ISetSendOnBehalfPermissionsVariables) => void;
	onSuccess?: (data: void, variables: ISetSendOnBehalfPermissionsVariables) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ permissions, user }: ISetSendOnBehalfPermissionsVariables) => {
			return userSession.webServiceHelper.callAsync<void>(
				`admin/userOperations/${encodeURIComponent(user.id)}/setSendOnBehalfPermissions`,
				'POST',
				permissions
			);
		},
		onError,
		onSettled: invalidateAllUsers,
		onSuccess,
	});
}
